import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import { ADMIN_PREFIX_PATH } from "configs/AppConfig";

import Loading from "components/shared-components/Loading";

import useModuleHeader from "hooks/Layout/ModuleHeader";

import "./assets/index.css";

export const AdminViews = () => {
  const { headerRef } = useModuleHeader();

  return (
    <Suspense fallback={<Loading cover="content" />}>
      <section className="app-main-content" style={{ marginTop: "100px" }}>
        <div className="app-main-content-inner" ref={headerRef}></div>
        <div
          style={{
            paddingBottom: "20px",
            paddingRight: "20px",
            paddingLeft: "20px",
            paddingTop: "20px",
          }}
        >
          <Switch>
            <Route
              path={`${ADMIN_PREFIX_PATH}/home`}
              component={lazy(() => import(`./components/Cars/Table`))}
            />
            <Route
              path={`${ADMIN_PREFIX_PATH}/rh/users`}
              component={lazy(() => import(`./components/User`))}
            />
            <Route
              path={`${ADMIN_PREFIX_PATH}/rh/users-v2`}
              component={lazy(() => import(`./components/User/UserListV2`))}
            />

            <Route
              path={`${ADMIN_PREFIX_PATH}/module`}
              component={lazy(() => import(`./components/Modulev2/index.js`))}
            />
            <Route
              path={`${ADMIN_PREFIX_PATH}/roles`}
              component={lazy(() => import(`./components/Roles`))}
            />
            <Route
              path={`${ADMIN_PREFIX_PATH}/role-module`}
              component={lazy(() => import(`./components/RoleModule`))}
            />
            <Route
              path={`${ADMIN_PREFIX_PATH}/clients`}
              component={lazy(() => import(`./components/Clients`))}
            />

            <Route
              path={`${ADMIN_PREFIX_PATH}/companies`}
              component={lazy(() => import(`./components/Companies`))}
            />

            <Route
              path={`${ADMIN_PREFIX_PATH}/positions`}
              component={lazy(() => import(`./components/Positions`))}
            />

            <Route
              path={`${ADMIN_PREFIX_PATH}/subsidiaries`}
              component={lazy(() => import(`./components/Subsidiaries`))}
            />

            <Route
              path={`${ADMIN_PREFIX_PATH}/cars`}
              component={lazy(() => import(`./components/Cars`))}
            />

            <Route
              path={`${ADMIN_PREFIX_PATH}/card-profile`}
              component={lazy(() => import(`./components/CardProfile`))}
            />

            <Route
              path={`${ADMIN_PREFIX_PATH}/refuelings`}
              component={lazy(() => import(`./components/Refuelings`))}
            />

            <Route
              path={`${ADMIN_PREFIX_PATH}/areas`}
              component={lazy(() => import(`./components/Areas`))}
            />

            <Route
              path={`${ADMIN_PREFIX_PATH}/departments`}
              component={lazy(() => import(`./components/Departments`))}
            />

            <Route
              path={`${ADMIN_PREFIX_PATH}/authorizations`}
              component={lazy(() => import(`./components/Authorizations`))}
            />

            <Route
              path={`${ADMIN_PREFIX_PATH}/authorization-tags`}
              component={lazy(() => import(`./components/AuthorizationsTags`))}
            />

            <Route
              path={`${ADMIN_PREFIX_PATH}/reports`}
              component={lazy(() =>
                import(`./components/Reports`)
              )}
            />
            <Route
              path={`${ADMIN_PREFIX_PATH}/pbi-reports`}
              component={lazy(() =>
                import(`./components/PbiReports`)
              )}
            />


            <Redirect
              from={`${ADMIN_PREFIX_PATH}`}
              to={`${ADMIN_PREFIX_PATH}/home`}
            />
          </Switch>
        </div>
      </section>
    </Suspense>
  );
};

export default React.memo(AdminViews);
